import script from "./UserMyShosai.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMyShosai.vue?vue&type=script&setup=true&lang=js"

import "./UserMyShosai.vue?vue&type=style&index=0&id=2ef55d40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef55d40"]])

export default __exports__